module.exports = __webpack_public_path__ + "img/brink3-cover.5c650b90.jpg";